import React from "react";
import { Menu } from "react-feather";
import "./header.css";
import isGHMC from "../../Common/helper/helpar";

const Header = ({ onToggleSidebar }) => {
  const roleName = localStorage.getItem("userName");
  const isProd = isGHMC();

  return (
    <div className="header d-print-none">
      <div className="header-container">
        <div className="header-left" aria-hidden="true" />

        <div className="header-body">
          <div className="header-toolbar">
            <button
              type="button"
              className="sidebar-header-toggle"
              onClick={onToggleSidebar}
              aria-label="Toggle sidebar"
            >
              <Menu />
            </button>
            <h4 className={`${isProd ? "text-blue" : "text-red"}`}>
              CENTRAL DELHI SOLID WASTE MANAGEMENT
            </h4>
          </div>

          <div className="header-body-right">
            <ul className="navbar-nav">
              <a href="#user-menu" className="m-0" title="User menu">
                <div>
                  <img src="/assets/images/user.png" alt="" className="img-fluid" />
                </div>
                <span
                  className="d-sm-inline d-none"
                  style={{ color: "black", fontWeight: "600" }}
                >
                  {roleName}
                </span>
              </a>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
